import React, { memo } from "react";

export const FittingsExample = memo(function FittingsExample() {
  return <img src="/img/fittings.png" />;
});
